import { AlertAction } from "./alert";
export class AlertHarnessController {
  public alertActions: AlertAction[];
  public showAlert = true;
  public alertDismissed = false;
  public showTimedAlert = true;
  public sampleDetailsMessage: string;
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery, private $scope: ng.IScope, private $timeout: ng.ITimeoutService) {
    this.alertActions = [
      { linkText: "test 1", url: "http://google.com", biId: "test_alert_action1" },
      { linkText: "test 2", url: "http://bing.com", biId: "test_alert_action1" }
    ];
    this.sampleDetailsMessage =
      "As we spend more time on handling live site issues, we noticed it's not enough to show a simple alert message for our Agents. The expandable alert details message give us option to show detailed error body, which will help our Agents and Engineers investigate errors more efficiently, it would be great if we can apply this consistent error handling across our platform";
  }

  public toggleAlert(): void {
    this.showAlert = !this.showAlert;
  }

  public resetTimedAlert() {
    this.$scope.$applyAsync(() => {
      this.showTimedAlert = false;
      this.$timeout(() => {
        this.$scope.$applyAsync(() => {
          this.showTimedAlert = true;
        });
      }, 100);
    });
  }
}
